import {LogOut} from 'lucide-react';
import {Button, NotFoundPage, Wordmark} from '@kroll-resolver-crisp/ui-components-react';
import {useAuth} from '../context/useAuth';

// Rendered instead of the app shell for a user Auth0 authenticated but granted nothing - no role,
// or no access:pri permission. Every endpoint in the API 403s for this user regardless of which page
// renders, so the SPA stops here rather than mounting a dashboard shell that would fire nothing but
// failed requests.
//
// The frame is the design system's standalone 404 with no code watermark, as it documents for a 403.
// It is given no `onReportSubmit`, so it offers no "Report a problem": PRI's feedback endpoint is one
// of the endpoints that 403s for this user, so the report would go nowhere.
export function NoAccessPage() {
  const {user, logout} = useAuth();

  return (
    <NotFoundPage
      code={false}
      brand={<Wordmark />}
      title="No access granted"
      description={`You signed in successfully${user?.username ? ` as ${user.username}` : ''}, but your account has not been granted access to this workspace in Auth0 yet. Ask an administrator to assign you a role, then sign in again.`}
      footer={
        <Button variant="ghost" size="sm" onClick={logout}>
          <LogOut />
          Sign out
        </Button>
      }
    />
  );
}
